module.exports = __webpack_public_path__ + "34438aab2b63898615765d2b4a5bcf64.png";